import React from 'react';
import { ReactDOM } from 'react-dom';
//scss
import './Menu.scss';
//react-redux
import { connect } from 'react-redux';
// action
import { slideMenu } from '../../redux/Nav/Actions/Nav.actions';
//icon
import Mail from '../Icons/MailMenu';
import Github from '../Icons/GithubMenu';
import LinkedIn from '../Icons/LinkedInMenu';
//scroll
import { Link } from 'react-scroll';

class Menu extends React.Component {
  constructor() {
    super();
    this.MenuOneRef = React.createRef();
    this.MenuTwoRef = React.createRef();
  }

  onHandleClick = e => {
    if (e.target.title === 'outside') {
      this.props.slideMenu();
    }
  };

  onHandleMenuClick = e => {
    this.props.slideMenu();
  };

  onHoverOn = e => {
    if (
      e.currentTarget.parentNode.getAttribute('class') === 'styledMenu_MenuOne'
    ) {
      const hover = this.MenuOneRef.current;
      hover.classList.toggle('styledMenu_MenuOne_hover');
    } else {
      const hover = this.MenuTwoRef.current;
      hover.classList.toggle('styledMenu_MenuTwo_hover');
    }
  };
  onHoverOut = e => {
    if (
      e.currentTarget.parentNode.getAttribute('class') === 'styledMenu_MenuOne'
    ) {
      const hover = this.MenuOneRef.current;
      hover.classList.toggle('styledMenu_MenuOne_hover');
    } else {
      const hover = this.MenuTwoRef.current;
      hover.classList.toggle('styledMenu_MenuTwo_hover');
    }
  };

  render() {
    const isFirefox = typeof InstallTrigger !== 'undefined';
    return (
      <>
        <div
          className="styledMenu-wrapper"
          title="outside"
          style={{
            transform: this.props.openSlide
              ? 'translateY(0)'
              : 'translateY(-100%)',
          }}
          onClick={e => this.onHandleClick(e)}
        >
          <div className="styledMenu">
            <div
              href="#one"
              className="styledMenu_MenuOne"
              style={{
                color:
                  this.props.scroll > 0.65
                    ? '#f98664'
                    : this.props.scroll > 0.28
                    ? '#7370a3'
                    : '#f98664',
              }}
            >
              <Link
                activeClass="active"
                to="Projects"
                spy={true}
                smooth={true}
                offset={50}
                duration={500}
                onClick={e => this.onHandleMenuClick(e)}
                onMouseEnter={e => this.onHoverOn(e)}
                onMouseLeave={e => this.onHoverOut(e)}
              >
                Projects
              </Link>
              <div
                className="styledMenu_MenuOne_underline"
                ref={this.MenuOneRef}
                style={{
                  backgroundColor:
                    this.props.scroll > 0.65
                      ? '#7370a3'
                      : this.props.scroll > 0.28
                      ? '#5fbda1'
                      : '#7370a3',
                }}
              ></div>
            </div>
            <div
              href="#two"
              className="styledMenu_MenuTwo"
              style={{
                color:
                  this.props.scroll > 0.65
                    ? '#f98664'
                    : this.props.scroll > 0.28
                    ? '#7370a3'
                    : '#f98664',
              }}
            >
              <Link
                activeClass="active"
                to="About"
                spy={true}
                smooth={true}
                offset={50}
                duration={500}
                onClick={e => this.onHandleMenuClick(e)}
                onMouseEnter={e => this.onHoverOn(e)}
                onMouseLeave={e => this.onHoverOut(e)}
              >
                About me
              </Link>
              <div
                className="styledMenu_MenuTwo_underline"
                ref={this.MenuTwoRef}
                style={{
                  backgroundColor:
                    this.props.scroll > 0.65
                      ? '#7370a3'
                      : this.props.scroll > 0.28
                      ? '#5fbda1'
                      : '#7370a3',
                }}
              ></div>
            </div>
            <div className="styledMenu_contact">
              <a
                href="mailto:william.thompson.harris@gmail.com?Subject=Hi!"
                target="_top"
              >
                <Mail
                  style={{
                    fill:
                      this.props.scroll > 0.65
                        ? '#f98664'
                        : this.props.scroll > 0.28
                        ? '#7370a3'
                        : '#f98664',
                  }}
                />
              </a>
              <a href="https://github.com/ThompsonHarris" target="_blank">
                <Github
                  style={{
                    fill:
                      this.props.scroll > 0.65
                        ? '#f98664'
                        : this.props.scroll > 0.28
                        ? '#7370a3'
                        : '#f98664',
                  }}
                />
              </a>
              <a
                href="https://www.linkedin.com/in/thompson-harris-97a528189/"
                target="_blank"
              >
                <LinkedIn
                  style={{
                    fill:
                      this.props.scroll > 0.65
                        ? '#f98664'
                        : this.props.scroll > 0.28
                        ? '#7370a3'
                        : '#f98664',
                  }}
                />
              </a>
            </div>
          </div>
        </div>
        {isFirefox ? (
          <div
            className="MenuFireBG"
            style={{
              transform: this.props.openSlide
                ? 'translateY(0)'
                : 'translateY(-100%)',
            }}
          ></div>
        ) : null}
      </>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  slideMenu: () => dispatch(slideMenu()),
});

export default connect(null, mapDispatchToProps)(Menu);
